export default __webpack_public_path__ + "static/voiceright-e1af04fc90862970a4396839dbaf2b17.png";